// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bought-notifications[data-v-2225cab8]{border:1px solid #6c6;font-size:1.6em;margin:20px 0 20px 20px;padding:20px}.bought-notifications .bought-icon[data-v-2225cab8]{margin-right:10px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
